module.exports = __webpack_public_path__ + "static/smartpay_21-field_service-67894504e4fbf87d7e702054f9997dd6.svg";